import { HeadsetMic } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#22c55e";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="Atendente"
    accent={accent}
    icon={<HeadsetMic sx={{ width: 15, height: 15, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={valuePill(accent)}>
      {data?.user?.name || "Atendente não selecionado"}
    </div>
  </NodeCard>
));
